import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

export type ReportTargetType = 'Space' | 'User' | 'Message' | 'Photo';

/** Files a report -- see ReportsController.CreateReport. targetId is a photo's own URL for TargetType 'Photo' (the public space response never exposes a numeric photo id), the entity's own id (as a string) for every other type. */
export const createReport = async (targetType: ReportTargetType, targetId: string, reason: string): Promise<void> => {
  const response = await apiService<{ id: string }>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_REPORTS,
    method: HTTP_METHODS.POST,
    body: { targetType, targetId, reason },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (!response.success) throw new Error(response.error || 'Failed to submit report');
};
